module.exports = __webpack_public_path__ + "static/media/dispatch_systemmoduleA-map.cac9967a.png";